import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "arrow-right",
  "use": "arrow-right-usage",
  "viewBox": "0 0 12 9",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 9\" id=\"arrow-right\">\n    <path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M10.463 4.47L7.5 1.505a.483.483 0 0 1 .683-.683l3.677 3.676a.483.483 0 0 1 0 .683L8.182 8.86a.483.483 0 0 1-.683-.683l2.741-2.741H.933a.483.483 0 0 1 0-.966h9.53z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol